import React from 'react';
import type { PolicySection } from '../../types/policy';
const linkStyles = 'text-purple-700 underline underline-offset-2 decoration-purple-300 hover:decoration-purple-700 hover:text-purple-900 transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-ivory rounded';
interface PolicySectionBodyProps {
  section: PolicySection;
}
export function PolicySectionBody({
  section
}: PolicySectionBodyProps) {
  return <section id={section.id} aria-labelledby={`${section.id}-heading`} className="scroll-mt-40 lg:scroll-mt-32 pt-12 first:pt-0" data-id="element-299" data-mp="b97q90tol1z0">
      <h2 id={`${section.id}-heading`} className="font-serif text-2xl md:text-3xl text-charcoal leading-snug border-l-2 border-purple-600 pl-5" data-id="element-300" data-mp="2f32wrdra8o8">
        <span className="text-purple-700" data-id="element-301" data-mp="3jpjaexd07ty0">{section.number}.</span>{' '}
        {section.title}
      </h2>

      <div className="mt-6 space-y-6" data-id="element-302" data-mp="3oodue2mpjojp">
        {section.blocks.map((block, index) => {
        switch (block.kind) {
          case 'sub':
            return <h3 key={index} className="font-serif text-lg md:text-xl text-purple-800 pt-4 pb-2 border-b border-purple-100" data-id="element-303" data-mp="3gs7c06q1b4d9">
                  <span className="tabular-nums" data-id="element-304" data-mp="3qs7whvzn3qj1">{block.number}</span>{' '}
                  {block.title}
                </h3>;
          case 'lead':
            return <p key={index} className="text-base font-semibold text-charcoal leading-relaxed" data-id="element-305" data-mp="2y3ac9nbvbjnn">
                  {block.text}
                </p>;
          case 'p':
            {
              const at = block.link ? block.text.indexOf(block.link.text) : -1;
              return <p key={index} className="text-base text-charcoal/80 leading-[1.8]" data-id="element-306" data-mp="2jayr2szp77o9">
                  {block.link && at >= 0 ? <>
                      {block.text.slice(0, at)}
                      <a href={block.link.href} className={linkStyles} data-id="element-307" data-mp="n8vp4mucpgfh">
                        {block.link.text}
                      </a>
                      {block.text.slice(at + block.link.text.length)}
                    </> : block.text}
                </p>;
            }
          case 'ul':
            return <ul key={index} className="space-y-3 pl-1" data-id="element-308" data-mp="4c3yfschbz1e">
                  {block.items.map((item, itemIndex) => <li key={itemIndex} className="relative pl-6 text-base text-charcoal/80 leading-[1.8]" data-id="element-309" data-mp="9944425f2zrz" data-mpi={itemIndex}>
                      <span aria-hidden="true" className="absolute left-0 top-[0.7em] h-1.5 w-1.5 rounded-full bg-purple-500" data-id="element-310" data-mp="1kosqaraujurq" />
                      {item.lead ? <>
                          <strong className="font-semibold text-charcoal" data-id="element-311" data-mp="357v2po2gv6gj">
                            {item.lead}
                          </strong>{' '}
                          {item.text}
                        </> : item.text}
                    </li>)}
                </ul>;
          case 'clause':
            return <p key={index} className="relative pl-14 text-base text-charcoal/80 leading-[1.8]" data-id="element-312" data-mp="2mgc5jxv4immf">
                  <span className="absolute left-0 font-semibold tabular-nums text-charcoal" data-id="element-313" data-mp="2cixr23srg7wr">
                    {block.number}
                  </span>
                  {block.lead ? <>
                      <strong className="font-semibold text-charcoal" data-id="element-314" data-mp="ar2tes3ca3xj">
                        {block.lead}
                      </strong>{' '}
                    </> : null}
                  {block.text}
                </p>;
          case 'contact':
            return <address key={index} className="not-italic rounded-2xl border border-purple-200 bg-purple-50 px-6 py-5" data-id="element-315" data-mp="2um63ulsut01l">
                  <p className="font-serif text-base text-charcoal mb-3" data-id="element-316" data-mp="2kvtnl5s2nt19">
                    {block.title}
                  </p>
                  <ul className="space-y-1.5" data-id="element-317" data-mp="2pnbmzpeg5lk4">
                    {block.lines.map((line, lineIndex) => <li key={lineIndex} className="text-base text-charcoal/80 leading-relaxed" data-id="element-318" data-mp="2bw6ia8w8232x" data-mpi={lineIndex}>
                        {line.label ? <span className="font-semibold text-charcoal" data-id="element-319" data-mp="21x8yfj9qqxq9">
                            {line.label}:{' '}
                          </span> : null}
                        {line.href ? <a href={line.href} className={linkStyles} {...line.href.startsWith('http') ? {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                  } : {}} data-id="element-320" data-mp="1nbtp7kg3oofy">
                            {line.value}
                          </a> : line.value}
                      </li>)}
                  </ul>
                </address>;
          default:
            return null;
        }
      })}
      </div>
    </section>;
}